import { Link } from "react-router-dom";
import { formatDate } from "../../utils/dateUtils";

function BbsListItem({ item, moduleName, currentPage, selectedCategory, isNotice = false, isActive = false }) {
  const resolvedModule = item.board_module_name || moduleName;
  const link = resolvedModule
    ? `/bbs/${resolvedModule}/${item.document_id}?page=${currentPage}&category=${selectedCategory}`
    : `/bbs/${item.document_id}?page=${currentPage}&category=${selectedCategory}`;

  return (
    <Link
      to={link}
      className={`group flex flex-col gap-3 rounded-2xl border px-5 py-4 transition ${
        isNotice
          ? "border-accent-400/40 bg-accent-400/10 hover:border-accent-300/70"
          : isActive
            ? "border-brand-400/60 bg-brand-400/10 shadow-glow"
            : "border-white/10 bg-ink-900/70 hover:border-brand-400/50 hover:bg-ink-900"
      }`}
    >
      <div className="flex flex-wrap items-center gap-2 text-xs text-ink-200">
        <span className="pill">#{item.document_id}</span>
        <span className="pill">{formatDate(item.created_at)}</span>
        <span className="pill">작성자 {item.author_nickname}</span>
        {/* <span className="pill">댓글 {item.comment_count ?? 0}</span> */}
        <span className="pill">조회 {item.view_count}</span>
        <span className="pill">추천 {item.like_count}</span>
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h3 className="text-lg font-semibold text-white transition group-hover:text-brand-200">
            {isNotice ? (
              <>
                <span className="chip chip-active">공지</span>
                {" "}
                {item.title} [{item.comment_count ?? 0}]
              </>
            ) : (
              <>
                <span className="chip">{item.category_name}</span>
                {" "}
                {item.title} [{item.comment_count ?? 0}]
              </>
            )}
          </h3>
        </div>
      </div>
    </Link>
  );
}

export default BbsListItem;
